import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Typography, Paper, Box, InputAdornment, TextField, Stack, IconButton, Checkbox } from '@mui/material';
import {
    setCurrentPage,
    setItems,
    setPaginationMeta,
    setItemsPerPage,
    setIsLoading,
    setAllQuestionRegistriesIds,
    setUnLockedAddToRegistryQuestionCount
} from 'store/ResponseTemplate/actions';
import { SET_LOADING } from 'store/actions';
import ResponseTemplateSidebar from './Sidebar';
import ResponseTemplateContent from './Content';
import ResponseTemplateModal from './Modal';
import MonthlyPrompt from './Content/MonthlyPrompt';
import { Clear, MoreHoriz, Search } from '@mui/icons-material';
import { debounce } from 'utils/globalFunctions';
import { setSearchText } from 'store/ResponseTemplate/actions';
import {
    GET_ALL_QUESTION_REGISTRIES,
    GET_ALL_QUESTION_REGISTRIES_IDS,
    GET_TOTAL_QUESTION_LOCKED_QUESTION_REGISTRIES,
    GET_TOTAL_UNLOCKED_QUESTIONS_REGISTRIES_COUNT
} from 'schemas/query';
import { useLazyQuery } from '@apollo/client';
import { checkIsFreemiumPlan, checkIsPremiumPlan } from 'helper/checkPlan.helper';
import FreemiumPlanWrapper from 'Components/FreemiumPlanWrapper';
import QuestionRegistryFremiumListing from 'Components/QuestionRegistryFremiumListing';
import deleteQuestionIcon from 'assets/images/dashboard/img-deleted.jpg';
import draftedQuestionIcon from 'assets/images/dashboard/img-drafts.jpg';
// import starredQuestion from 'assets/images/dashboard/img-starred.jpg';
import starredQuestion from 'assets/images/dashboard/img-starred.svg';
import { setLockedAddToRegistryQuestionCount } from 'store/ResponseTemplate/actions';
import StarIcon from 'Components/Icons/StarIcon';
import QuestionRegistryCard from './QuestionRegistryCard';
import QuestionCardInformation from './QuestionCardInformation';
import NewQuestionCard from './FreemiumQuestionCard';
import ImportQuestionCSVCard from './ImportQuestionCSVCard';
import { removeDuplicatesAndModifiedFromLatestArray, removeDuplicatesFromArray } from 'helper/array.helper';
import ResponseTemplate from '.';

function QuestionRegistryExtension() {
    return <ResponseTemplate isNotExtension={false} />;
}

export default QuestionRegistryExtension;
